const debounce = <A extends unknown[]>(fn: (...args: A) => void, delay: number) => {
  let timer: ReturnType<typeof setTimeout>
  return (...args: A) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

export { debounce }
